/** Limits concurrent authenticated preview blob fetches to avoid freezing the browser. */
const MAX_CONCURRENT = 3
let active = 0
const queue: Array<() => void> = []

function drain() {
  while (active < MAX_CONCURRENT && queue.length > 0) {
    const run = queue.shift()
    if (run) run()
  }
}

export function schedulePreviewFetch<T>(task: () => Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    const run = () => {
      active += 1
      void task()
        .then(resolve, reject)
        .finally(() => {
          active -= 1
          drain()
        })
    }
    if (active < MAX_CONCURRENT) {
      run()
    } else {
      queue.push(run)
    }
  })
}
